import React from "react";
// import AddClothForm from "../../../views/settings/AddClothForm";
import { Modal, Loading } from "../../../core";
import { Row, Col, Form } from "antd";
import { Typography, Input, Button } from "../../../core";
// import AddYarnQualityForm from "../../../views/settings/AddYarnQualityForm";
import { addHsCode } from "../../../helper/utils/api/settings";

const layout = {
  wrapperCol: {
    span: 24,
  },
};
const btnProps = {
  width: "187px",
  bg: "#404E67",
  type: "primary",
  htmlType: "submit",
};
const typoProps = {
  align: "center",
  as: "h3",
  weight: "600",
  color: "white",
};

const AddSelvedgeModal = ({ addHsCodeModal, getHsCode, closeModal }) => {
  const companyId = localStorage.getItem("companyId");
  const [hsCode, setHsCode] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(false);
  const [form] = Form.useForm();

  const onValuesChange = (changedValues, newHsCode) => {
    const { hsCode } = newHsCode;

    setHsCode((prev) => ({
      ...prev,
      companyId,
      hsCode,
    }));
  };

  const closeModalHandler = () => {
    closeModal("addHsCodeModal");
  };

  const onFinish = (values) => {
    createHsCode();
  };

  const createHsCode = async () => {
    setIsLoading(true);

    try {
      let response = await addHsCode(hsCode);
      closeModalHandler();
      getHsCode();
      console.log("response", response);
    } catch (error) {
      console.log("error add hsCode ", error);
    }

    setIsLoading(false);
  };

  const onFinishFailed = () => {};
  return (
    <Modal
      closable={true}
      visible={addHsCodeModal}
      okText="Add"
      maxwidth="568px"
      footer={false}
      onCancel={() => closeModal("addHsCodeModal")}
      tittle="Add Hs Code"
    >
      {isLoading ? <Loading /> : null}
      {/* <AddClothForm getHsCode={getHsCode} closeModal={closeModal} /> */}

      <Form
        form={form}
        {...layout}
        name="basic"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        onValuesChange={onValuesChange}
      >
        <Row type="flex" justify="center" gutter={[16, 16]}>
          <Col sm={12} xs={24}>
            <Form.Item
              name="hsCode"
              rules={[
                {
                  required: true,
                  message: "Please Input Hs Code Value",
                },
              ]}
            >
              <Input type="text" className="text-center" placeholder="Weave" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button {...btnProps}>
            <Typography {...typoProps} text="Add" />
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddSelvedgeModal;
